import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import "react-circular-progressbar/dist/styles.css"
import "./stats.css"

const Stats = () => {
  const [crs, setCrs] = useState([])
  const [enrols, setEnrols] = useState([])
  const [filterVal, setFilterVal] = useState([])
  const { courses } = useSelector((state) => state.course)
  const { enrollments } = useSelector((state) => state.enroll)

  useEffect(() => {
    courses && setCrs(courses)
  }, [courses])

  const handleFilter = (e) => {
    const value = e.target.value
    setFilterVal(value)
    localStorage.setItem("dashboardFilter", value)
    updateList()
  }

  const updateList = () => {
    const filter = localStorage.getItem("dashboardFilter")

    filter &&
      setEnrols(enrollments.filter((e) => e.course.courseCode === filter))
  }

  const totalDueSoon = enrols.reduce((total, item) => {
    const sum = item?.payment?.installment.reduce((count, ins) => {
      if (ins.status === "due soon") {
        count++
      }
      return count
    }, 0)
    return total + sum
  }, 0)

  return (
    <div className="stats">
      <div className="stats-top">
        <select
          name="batch"
          onChange={handleFilter}
          defaultValue="Select a batch"
        >
          <option disabled defaultChecked>
            Select a batch
          </option>
          {crs?.map((c) => (
            <option
              key={c._id}
              value={c.courseCode}
              defaultValue={c.courseCode === localStorage.getItem("filter")}
            >
              {c.courseCode}
            </option>
          ))}
        </select>
      </div>

      <div className="stats-bottom">
        {/* <div className="revChart">
          <CircularProgressbar value={70} text={"70%"} strokeWidth={5} />
        </div> */}
        <p className="stats-title">Total no. of students in this batch</p>
        <p className="figure">{enrols?.length}</p>
        {/* <p className="desc">
          Previous transactions processing. Last payments may not be included.
        </p> */}
      </div>
      <hr />
      <div className="stats-bottom">
        <p className="stats-title">Total no. of payments due in this batch</p>
        <p className={totalDueSoon === 0 ? "figure" : "figure text-danger"}>
          {totalDueSoon}
        </p>
      </div>
    </div>
  )
}

export default Stats
